/* ============================================================
   CREATOR REELS — v110

   Five jobs. The fourth (v110) is mouse drag + arrows on the reel row, the
   fifth (v110) is the full-screen viewer on /pages/reels; both sit just
   above section 3 because section 3 returns early:
     1. Nothing downloads until the player is near the screen, and the file
        it downloads depends on how many DEVICE pixels the player actually
        occupies. See pickSource().
     2. Play while visible, pause when not. One reel has sound at a time.
     3. On a collection page, drop the reel band into the grid AFTER a whole
        number of product rows — which is a number only the browser knows,
        because the grid is 4 / 3 / 2 columns by width.

   ORDER OF OPERATIONS ON A COLLECTION PAGE
   vibe-lens.liquid re-appends every .card to lift merchandised picks, so any
   position this file chooses before that runs is thrown away. The band is
   therefore rendered last in the grid and hidden, and placed from here after
   the sort — on load, on resize, and whenever the filters hide or show a card
   (the observer below). If this file never runs, the band stays hidden and
   the grid is exactly as it was.
   ============================================================ */
(function () {
  'use strict';

  var reduce = window.matchMedia &&
               window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var vids = [].slice.call(document.querySelectorAll('video[data-reel-src]'));

  /* ---------- 1. load ----------

     WHICH FILE, AND WHY IT IS NOT A WIDTH TEST

     Shopify transcodes each vertical upload to three widths:

         SD   480p   270 x  480
         HD   720p   404 x  720
         HD  1080p   606 x 1080

     What decides which one looks right is not the viewport — it is how many
     device pixels the player is painted into, which is its CSS width times
     the pixel ratio:

         phone  375px viewport -> 255px player x3 = 765 device px
         phone                 -> 255px player x2 = 510 device px
         laptop                -> 291px player x1 = 291 device px
         laptop retina         -> 312px player x2 = 624 device px

     v100 CHOSE BETWEEN TWO FILES AND STOPPED AT 720p. That is why the clips
     still looked soft on a phone after the v100 fix: a 3x phone paints 765
     device pixels and was being handed the 404-wide file, a 1.9x upscale —
     almost exactly the same stretch the pre-v100 code produced, just one rung
     higher up the ladder. The 606-wide file existed on every one of these
     uploads the whole time and was never referenced.

     So: measure the element, multiply by the ratio, and take the SMALLEST
     rendition that does not have to stretch. Nothing is upscaled unless the
     device asks for more pixels than Shopify made, in which case the widest
     available is the best there is (765 asked, 606 given, 1.26x — that is the
     ceiling, not a bug).

     THE COST IS REAL AND IS THE REASON FOR THE FLOOR BELOW. 1080p is 7.2Mbps
     against 720p's 4.5 and 480p's 1.5 — the 24.7s lead clip is 22MB watched
     end to end against 14MB and 5MB. Files stream as they play and preload is
     none, so a scroll-past costs a fraction of that, but on a metered or slow
     connection the trade is still wrong.

     THE FLOOR, AND WHY 3g NO LONGER MEANS 480p  (2026-09-21)
     effectiveType is NOT the radio. It is a label the browser derives from a
     rolling estimate of round-trip time and throughput, and its 3g band opens
     at ~270ms RTT — which a perfectly healthy Indian 4G connection hits all
     day on a busy cell or a distant CDN edge. So the old rule, which put
     saveData, 2g AND 3g on the 270px file, was handing 480p to phones with
     bandwidth to spare, on the strength of a latency reading. That is a much
     more visible kind of soft than any upscale, and it is invisible in
     testing because a desk connection always reports 4g.

     Now: only saveData and a genuine 2g / slow-2g reading drop to the
     smallest file. A 3g reading caps the choice at 720p — 4.5Mbps, which any
     connection that is really 3g-or-better can carry — instead of flooring
     it. Cautious where caution is warranted, without punishing a good
     connection for being far from the server.

     THE ID GUARD. The HD and 1080p addresses are defaults baked into
     snippets/creator-reels.liquid. If someone swaps a clip in the theme
     editor they change the SD address, and the big files would then point at
     a DIFFERENT VIDEO — the wrong clip, in higher quality, which is worse
     than soft. Every candidate therefore has to carry the same Shopify video
     id as the SD source or it is dropped. Mismatched setup degrades to the
     file that is definitely right. */
  var RENDITIONS = [
    { attr: 'data-reel-src',     w: 270 },
    { attr: 'data-reel-src-hd',  w: 404 },
    { attr: 'data-reel-src-fhd', w: 606 }
  ];

  function videoId(url) {
    var m = /\/vp\/([0-9a-f]{16,})\//.exec(url || '');
    return m ? m[1] : '';
  }

  function ladder(v) {
    var sd = v.getAttribute('data-reel-src') || '';
    var base = videoId(sd);
    var out = [];
    RENDITIONS.forEach(function (r) {
      var u = v.getAttribute(r.attr);
      if (!u) return;
      if (base && videoId(u) !== base) return;   /* see THE ID GUARD above */
      out.push({ u: u, w: r.w });
    });
    if (!out.length) out.push({ u: sd, w: 270 });
    out.sort(function (a, b) { return a.w - b.w; });
    return out;
  }

  function pickSource(v, cssWidth) {
    var list = ladder(v);

    var c = navigator.connection;
    var eff = (c && c.effectiveType) || '';

    /* Matches '2g' and 'slow-2g', and deliberately NOT '3g'. */
    if (c && (c.saveData || /(^|-)2g$/.test(eff))) return list[0].u;

    var cap = /(^|-)3g$/.test(eff) ? 404 : Infinity;

    /* cssWidth: the full-screen viewer (section 5) sizes for ITS player,
       not for the tile the file addresses were read from. */
    var css = cssWidth || (v && v.getBoundingClientRect().width) || 0;
    if (!css) css = window.innerWidth >= 900 ? 291 : 255;   /* not laid out yet */
    var need = css * (window.devicePixelRatio || 1);

    /* Smallest rendition that covers `need`, never above `cap`, and never
       below the first rung — a cap tighter than every file still plays. */
    var chosen = list[0];
    for (var i = 0; i < list.length; i++) {
      if (list[i].w > cap) break;
      chosen = list[i];
      if (list[i].w >= need) break;
    }
    return chosen.u;
  }

  function load(v) {
    if (v.getAttribute('data-loaded')) return;
    v.setAttribute('data-loaded', '1');
    v.src = pickSource(v);
    v.load();
  }

  function play(v) {
    if (reduce) return;
    var p = v.play();
    if (p && p.catch) p.catch(function () { /* autoplay refused; poster stands */ });
  }

  if (vids.length) {
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting) { load(v); play(v); }
          else if (!v.paused) { v.pause(); }
        });
      }, { rootMargin: '200px 0px', threshold: 0.25 });
      vids.forEach(function (v) { io.observe(v); });
    } else {
      vids.forEach(function (v) { load(v); play(v); });
    }
  }

  /* ---------- 2. sound ---------- */
  function setBtn(btn, on) {
    if (!btn) return;
    btn.classList.toggle('is-on', on);
    btn.setAttribute('aria-label', on ? 'Turn sound off' : 'Turn sound on');
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-reel-sound]');
    if (!btn) return;
    e.preventDefault();

    var fig = btn.closest('[data-reel]');
    var v = fig && fig.querySelector('video');
    if (!v) return;

    var turningOn = v.muted;

    /* Two reels talking over each other is nobody's idea of a storefront. */
    vids.forEach(function (o) {
      if (o === v) return;
      o.muted = true;
      var f = o.closest('[data-reel]');
      setBtn(f && f.querySelector('[data-reel-sound]'), false);
    });

    v.muted = !turningOn;
    setBtn(btn, turningOn);
    if (turningOn) { load(v); play(v); }
  });

  /* ---------- 4. desktop: drag with the mouse, and arrows  (v110) ----------

     Dev, 2026-09-27: "its not swipable in desktop". A phone swipes the row
     natively; a laptop could only scroll it with a trackpad's sideways
     gesture or shift+wheel, which nobody knows to try. So:

       - press and drag with a MOUSE scrolls the row. Pointer type is
         checked, so touch and pen keep the browser's own swipe untouched.
       - a drag that moved more than a few pixels swallows the click that
         follows, or letting go over a clip would open the collection.
       - the arrows scroll by the width of the players that are fully on
         screen, and hide at either end and when everything already fits.

     Snapping is switched off while dragging (CSS, .is-dragging) and comes
     back on release, which settles the row onto the nearest player. */
  function slider(box) {
    var row = box.querySelector('[data-reel-row]');
    if (!row) return;
    var prev = box.querySelector('[data-reel-prev]');
    var next = box.querySelector('[data-reel-next]');

    function step() {
      var reel = row.querySelector('.reel');
      if (!reel) return row.clientWidth * 0.8;
      var gap = parseFloat(getComputedStyle(row).columnGap) || 16;
      var w = reel.getBoundingClientRect().width + gap;
      return Math.max(w, Math.floor(row.clientWidth / w) * w);
    }

    function arrows() {
      if (!prev || !next) return;
      var max = row.scrollWidth - row.clientWidth;
      var fits = max <= 2;
      prev.hidden = fits; next.hidden = fits;
      prev.disabled = row.scrollLeft <= 2;
      next.disabled = row.scrollLeft >= max - 2;
    }

    if (prev) prev.addEventListener('click', function () {
      row.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' });
    });
    if (next) next.addEventListener('click', function () {
      row.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' });
    });
    row.addEventListener('scroll', arrows, { passive: true });
    window.addEventListener('resize', arrows);
    window.addEventListener('load', arrows);
    arrows();

    var down = false, moved = false, startX = 0, startLeft = 0, pid = null;

    row.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      if (e.target.closest('[data-reel-sound], .reel-ig')) return;
      down = true; moved = false;
      startX = e.clientX; startLeft = row.scrollLeft; pid = e.pointerId;
    });

    row.addEventListener('pointermove', function (e) {
      if (!down || e.pointerId !== pid) return;
      var dx = e.clientX - startX;
      if (!moved) {
        if (Math.abs(dx) < 6) return;
        moved = true;
        row.classList.add('is-dragging');
        try { row.setPointerCapture(pid); } catch (err) {}
      }
      row.scrollLeft = startLeft - dx;
      e.preventDefault();
    });

    function end(e) {
      if (!down || (e && e.pointerId !== pid)) return;
      down = false;
      try { row.releasePointerCapture(pid); } catch (err) {}
      if (moved) {
        row.classList.remove('is-dragging');
        /* The click fires after pointerup; eat exactly that one. */
        var eat = function (ev) { ev.preventDefault(); ev.stopPropagation(); };
        row.addEventListener('click', eat, { capture: true, once: true });
        setTimeout(function () { row.removeEventListener('click', eat, true); }, 350);
      }
    }
    row.addEventListener('pointerup', end);
    row.addEventListener('pointercancel', end);

    /* Stop the browser's own drag-the-link / drag-the-image ghost. */
    row.addEventListener('dragstart', function (e) { e.preventDefault(); });

    return arrows;
  }

  /* The collection band is hidden until section 3 places it, and a hidden
     row measures 0 wide, so its arrows are re-checked after every placement. */
  var refreshArrows = [].slice.call(document.querySelectorAll('[data-reel-slider]'))
    .map(slider).filter(Boolean);

  /* ---------- 5. the reels page: tap a tile, watch it full screen  (v110) ----------

     /pages/reels is the Instagram-explore grid (sections/main-reels.liquid).
     Tiles play silently while on screen; a tap opens that reel full screen
     WITH sound (the tap is the user gesture browsers require for sound), and
     the viewer moves between reels like Instagram does:

         phone    swipe up = next, swipe down = previous, tap = pause/play
         laptop   arrow buttons, arrow keys, Esc to close

     Each tile is still a real link to the collection underneath, so if this
     script never runs the tap simply goes shopping. One <video> is reused for
     every reel, sized to the screen: a phone is handed the 1080p file here
     even though its tile played the small one. */
  function viewer(grid) {
    var figs = [].slice.call(grid.querySelectorAll('[data-reel]'));
    if (!figs.length) return;

    var ICON_X = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
    var ICON_UP = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 15l-6-6-6 6"/></svg>';
    var ICON_DN = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';
    var ICON_IG = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="5"></rect><circle cx="12" cy="12" r="4"></circle><circle cx="17.3" cy="6.7" r="1" fill="currentColor" stroke="none"></circle></svg>';
    var ICON_ON = '<svg class="on" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><path d="M15.5 8.5a5 5 0 0 1 0 7"></path><path d="M18.5 5.5a9 9 0 0 1 0 13"></path></svg>';
    var ICON_OFF = '<svg class="off" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><line x1="22" y1="9" x2="16" y2="15"></line><line x1="16" y1="9" x2="22" y2="15"></line></svg>';

    var box = document.createElement('div');
    box.className = 'reel-viewer';
    box.hidden = true;
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Reel');
    box.innerHTML =
      '<div class="rv-stage">' +
        '<video playsinline loop preload="auto" disablepictureinpicture></video>' +
        '<div class="rv-top"><span class="rv-count"></span>' +
          '<button type="button" class="rv-btn rv-close" aria-label="Close">' + ICON_X + '</button></div>' +
        '<div class="rv-bar">' +
          '<b class="rv-cap"></b>' +
          '<div class="rv-actions">' +
            '<a class="rv-shop" href="/collections/women">Shop the frames <span aria-hidden="true">&rarr;</span></a>' +
            '<a class="rv-btn rv-ig" target="_blank" rel="noopener" aria-label="Watch on Instagram">' + ICON_IG + '</a>' +
            '<button type="button" class="rv-btn rv-sound" aria-label="Turn sound off">' + ICON_ON + ICON_OFF + '</button>' +
          '</div>' +
        '</div>' +
      '</div>' +
      '<button type="button" class="rv-btn rv-nav rv-prev" aria-label="Previous reel">' + ICON_UP + '</button>' +
      '<button type="button" class="rv-btn rv-nav rv-next" aria-label="Next reel">' + ICON_DN + '</button>';
    document.body.appendChild(box);

    var v = box.querySelector('video');
    var cap = box.querySelector('.rv-cap');
    var count = box.querySelector('.rv-count');
    var shop = box.querySelector('.rv-shop');
    var ig = box.querySelector('.rv-ig');
    var snd = box.querySelector('.rv-sound');
    var idx = 0, muted = false, lastFocus = null;

    function setSound() {
      v.muted = muted;
      snd.classList.toggle('is-muted', muted);
      snd.setAttribute('aria-label', muted ? 'Turn sound on' : 'Turn sound off');
    }

    function show(i) {
      idx = (i + figs.length) % figs.length;
      var f = figs[idx];
      var tv = f.querySelector('video');
      var w = Math.min(window.innerWidth, window.innerHeight * 9 / 16);
      v.poster = tv.getAttribute('poster') || '';
      v.src = pickSource(tv, w);
      setSound();
      var p = v.play();
      /* Sound refused (rare after a tap): play silently rather than not at all. */
      if (p && p.catch) p.catch(function () { muted = true; setSound(); v.play().catch(function () {}); });

      var c = f.querySelector('figcaption b');
      cap.textContent = c ? c.textContent : '';
      var a = f.querySelector('.reel-ig');
      if (a) { ig.href = a.href; ig.hidden = false; } else { ig.hidden = true; }
      var st = f.querySelector('.reel-stage');
      if (st) shop.href = st.getAttribute('href');
      count.textContent = (idx + 1) + ' / ' + figs.length;
    }

    function tiles(action) {
      figs.forEach(function (f) {
        var tv = f.querySelector('video');
        if (!tv) return;
        if (action === 'pause') { tv.pause(); return; }
        var r = tv.getBoundingClientRect();
        if (r.bottom > 0 && r.top < window.innerHeight) play(tv);
      });
    }

    function open(i) {
      lastFocus = document.activeElement;
      tiles('pause');
      box.hidden = false;
      document.body.classList.add('rv-locked');
      show(i);
      box.querySelector('.rv-close').focus();
    }

    function close() {
      v.pause();
      v.removeAttribute('src');
      v.load();
      box.hidden = true;
      document.body.classList.remove('rv-locked');
      tiles('play');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    grid.addEventListener('click', function (e) {
      var st = e.target.closest('.reel-stage');
      if (!st) return;
      var f = st.closest('[data-reel]');
      var i = figs.indexOf(f);
      if (i < 0) return;
      e.preventDefault();
      open(i);
    });

    box.querySelector('.rv-close').addEventListener('click', close);
    box.querySelector('.rv-prev').addEventListener('click', function () { show(idx - 1); });
    box.querySelector('.rv-next').addEventListener('click', function () { show(idx + 1); });
    snd.addEventListener('click', function () { muted = !muted; setSound(); if (!muted) v.play().catch(function () {}); });
    v.addEventListener('click', function () { if (v.paused) v.play().catch(function () {}); else v.pause(); });

    document.addEventListener('keydown', function (e) {
      if (box.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowDown' || e.key === 'ArrowRight') { e.preventDefault(); show(idx + 1); }
      else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') { e.preventDefault(); show(idx - 1); }
    });

    /* Swipe up for the next reel, down for the previous — the Reels gesture.
       touch-action:none on the viewer (CSS) stops the page from scrolling
       behind it while the finger moves. */
    var y0 = null, x0 = null;
    box.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      y0 = e.touches[0].clientY; x0 = e.touches[0].clientX;
    }, { passive: true });
    box.addEventListener('touchend', function (e) {
      if (y0 === null) return;
      var t = e.changedTouches[0];
      var dy = t.clientY - y0, dx = t.clientX - x0;
      y0 = null;
      if (Math.abs(dy) > 60 && Math.abs(dy) > Math.abs(dx)) show(idx + (dy < 0 ? 1 : -1));
    });

    window.addEventListener('pagehide', function () { if (!box.hidden) close(); });
  }

  [].slice.call(document.querySelectorAll('[data-reel-grid]')).forEach(viewer);

  /* ---------- 3. placement in the collection grid ---------- */
  var grid = document.querySelector('.collection-body .product-grid[data-tbt-grid]');
  var tile = document.querySelector('[data-reel-tile]');
  if (!grid || !tile) return;

  var ROWS = parseInt(tile.getAttribute('data-rows'), 10) || 2;

  function visibleCards() {
    return [].slice.call(grid.querySelectorAll('.card')).filter(function (c) {
      return !c.hidden;
    });
  }

  /* How many cards share the top edge of the first one. The only honest way
     to read a column count that CSS decides. */
  function columns(vis) {
    if (!vis.length) return 0;
    var top = vis[0].offsetTop, n = 0;
    for (var i = 0; i < vis.length; i++) {
      if (Math.abs(vis[i].offsetTop - top) < 4) n++; else break;
    }
    return n;
  }

  function place() {
    /* Measure with the band out of the flow, or it moves the rows it is
       trying to count. */
    tile.hidden = true;

    var vis = visibleCards();
    var cols = columns(vis);
    var after = cols * ROWS;

    /* Needs a full row of frames below it, otherwise it is not a break in
       the browse — it is the end of the page with a video stuck on it. */
    if (!cols || vis.length < after + cols) return;

    var ref = vis[after - 1];
    if (ref.nextSibling !== tile) grid.insertBefore(tile, ref.nextSibling);
    tile.hidden = false;
    refreshArrows.forEach(function (f) { f(); });
  }

  var mo = null, raf = null;

  function run() {
    if (mo) mo.disconnect();
    place();
    if (mo) mo.observe(grid, {
      attributes: true, attributeFilter: ['hidden'],
      subtree: true, childList: true
    });
  }

  function schedule() {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(function () { raf = null; run(); });
  }

  if ('MutationObserver' in window) mo = new MutationObserver(schedule);

  function boot() {
    run();
    /* vibe-lens retries for up to two seconds if the grid arrives late. */
    setTimeout(schedule, 400);
    setTimeout(schedule, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('load', schedule);
  window.addEventListener('resize', schedule);
})();
